import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoginService } from 'src/app/services/login/login.service';
import { environment } from 'src/environments/environment'
import { IridiumSubscriptionGQLService } from './../../../services/iridium/iridium-subscription-gql.service';
import { ToastrService } from 'ngx-toastr';
import { CommonServiceService } from 'src/app/services/commonService/common-service.service';
import { SideBarOptions } from 'src/app/models/sidebar/sidebar.model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';




@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  public visualB = false;
  @Input() sideNavStatus: boolean;
  @Output() titleEmitter: EventEmitter<string> = new EventEmitter<string>();
  userRole: string[];
  hasIridiumOption: boolean = false;
  data: any;
  iridiumSubscription: Subscription;
  userAuthenticated: boolean = false;
  sidebarOptions: SideBarOptions;

  constructor(
    private loginService: LoginService,
    private iridiumService: IridiumSubscriptionGQLService,
    private toastrservice: ToastrService,
    private commonService: CommonServiceService,
    private router: Router
  ) {
    this.checkUserRole();
    this.hasIridiumOption = JSON.parse(environment.iridium);
    this.listenToIridiumEvents();
  }

  ngOnInit() {
    this.checkUserRole();
    this.getSidebarData();
    this.getFirstValueOfTitleSection();
  }

  getSidebarData() {
    this.commonService.getSidebarData().subscribe((data) => {
      this.sidebarOptions = data;
      this.sidebarOptions.accordions.map(r => {
        r.children.map(c => {
          if (this.userRole.some(r => c.roles.indexOf(r) >= 0) || (c.roles.length == 0 )) {
            c["visible"] = true;
            r["visible"] = true;
          }
        })
      })
    })
  }

  getFirstValueOfTitleSection() {
    switch (window.location.pathname) {
      case "/login":
        this.titleEmitter.emit("TITLES.HOME");
        break;
      case "/":
        this.titleEmitter.emit("TITLES.HOME");
        break;
      case "/dashboard":
        this.titleEmitter.emit("TITLES.DASHBOARD");
        break;
      case "/graphics":
        this.titleEmitter.emit("TITLES.GRAPHICS");
        break;
      case "/tables":
        this.titleEmitter.emit("TITLES.TABLES");
        break;
      case "/devices":
        this.titleEmitter.emit("TITLES.DEVICES");
        break;
      case "/alarmas":
        this.titleEmitter.emit("TITLES.ALARMS");
        break;
      case "/incidents":
        this.titleEmitter.emit("TITLES.INCIDENTS");
        break;
      case "/orders":
        this.titleEmitter.emit("TITLES.ORDENES");
        break;
      case "/gunnings":
        this.titleEmitter.emit("TITLES.GUNITADOS");
        break;
      case "/tundish":
        this.titleEmitter.emit("TITLES.TUNDISH");
        break;
      case "/users":
        this.titleEmitter.emit("TITLES.USERS");
        break;
      case "/status":
        this.titleEmitter.emit("TITLES.STATUS");
        break;
    }
  }

  emitTitle(title) {
    this.titleEmitter.emit(title);
  }

  visualToggle() {
    this.visualB = !this.visualB;
  }

  checkUserRole() {
    this.userRole = this.loginService.currentUserValue.rol;
  }

  listenToIridiumEvents() {
    if (localStorage.getItem("loggedUser") && this.hasIridiumOption === true) {
      this.iridiumSubscription = this.iridiumService
        .listen()
        .subscribe((res) => {
          this.toastrservice.warning(
            "Navege a la sección Iridium para visualizarla",
            "Recibida alarma vía Iridium",
            { closeButton: true, disableTimeOut: true }
          );
        });
    }
  }

  ngOnDestroy() {
    if (localStorage.getItem("loggedUser") && this.hasIridiumOption === true)
      this.iridiumSubscription.unsubscribe();
  }
}
